import React from 'react';
import { Grid, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';

const StyledGrid = styled(Grid)(({ theme }) => ({
  '& .imgBox': {
    height: theme.spacing(36.5),
    maxWidth: '100%',
  },
  '& .loadMore': {
    margin: `${theme.spacing(2)} auto`,
  },
}));

const InstagramGallerySkeleton = () => (
  <StyledGrid container spacing={2}>
    <Grid item xs={12} md={6} lg={3}>
      <Box className="imgBox">
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Box>
    </Grid>
    <Grid item xs={12} md={6} lg={3}>
      <Box className="imgBox">
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Box>
    </Grid>
    <Grid item xs={12} md={6} lg={3}>
      <Box className="imgBox">
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Box>
    </Grid>
    <Grid item xs={12} md={6} lg={3}>
      <Box className="imgBox">
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Box>
    </Grid>
    <Box className="loadMore">
      <Skeleton variant="rectangular" width="80px" height="20px" />
    </Box>
  </StyledGrid>
);

export default InstagramGallerySkeleton;
